
import sanityClient from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'


export const client = sanityClient({
    projectId:'ykkrqxtg',
    dataset: 'production',
    apiVersion: '2023-01-13',
    useCdn: 'true',
    token: 'skE1n20ANuFyFzsbn3sf8fm8L9e37DXmKr485KaUUpvVCiUXyn9vKR16xS424TgTg70CZgamZPbMdB3iYANt7I6mwgSn3CSaC7NxM8anDLIo1ma6aXPSj5qMhhCnnyfezsmLjdACT18K8PDOUIgJE7KoEjfuCmsYDiEvrNYlXbhUoPqF2XgA',
})

const builder = imageUrlBuilder(client)

export const urlFor = (source)=>{
    return builder.image(source)
}